// Columnas de tabla estándar. Los ids coinciden con el catálogo del backend (features/grupos/grupos.tabla.js).
// Generado con apis-node/scripts/columnas-front.mjs: si se añade una columna allí, se regenera aquí
// (el backend rechaza ids que no conozca).

export const COLUMNAS_GRUPOS = [
  {
    id: 'codigo',
    label: 'ID',
    width: 90,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Grupo',
  },
  {
    id: 'empresaId',
    label: 'Empresa',
    width: 120,
    sortable: true,
    filter: 'multi',
    group: 'General',
  },
  { id: 'grupo', label: 'Grupo', width: 240, sortable: true, filter: 'text', group: 'Grupo' },
  {
    id: 'horas',
    label: 'Horas',
    width: 90,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Académico',
  },
  {
    id: 'areaAcademica',
    label: 'Área académica',
    width: 200,
    sortable: true,
    filter: 'multi',
    group: 'Académico',
  },
  {
    id: 'leyeducativa',
    label: 'Ley educativa',
    width: 130,
    sortable: true,
    filter: 'multi',
    group: 'Académico',
  },
  {
    id: 'anyo',
    label: 'Año escolar',
    width: 120,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Académico',
  },
  {
    id: 'maxAlumnos',
    label: 'Máximo alumnos',
    width: 130,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Ocupación',
  },
  {
    id: 'disponible',
    label: 'Disponible',
    width: 110,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Ocupación',
  },
  {
    id: 'altas',
    label: 'Altas',
    width: 90,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Ocupación',
  },
  {
    id: 'bajas',
    label: 'Bajas',
    width: 90,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Ocupación',
  },
  { id: 'estado', label: 'Estado', width: 130, sortable: true, filter: 'multi', group: 'Grupo' },
  {
    id: 'fechaInicio',
    label: 'Inicio',
    width: 120,
    sortable: true,
    filter: 'date',
    defaultVisible: false,
    group: 'Fechas',
  },
  {
    id: 'fechaFin',
    label: 'Fin',
    width: 120,
    sortable: true,
    filter: 'date',
    defaultVisible: false,
    group: 'Fechas',
  },
  { id: 'actions', label: 'Acciones', width: 72, fixed: true },
];

export const COLUMNAS_PROFESORES = [
  {
    id: 'codigo',
    label: 'Código',
    width: 100,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Identificación',
  },
  {
    id: 'empresaId',
    label: 'Empresa',
    width: 120,
    sortable: true,
    filter: 'multi',
    group: 'General',
  },
  {
    id: 'nombre',
    label: 'Nombre',
    width: 160,
    sortable: true,
    filter: 'text',
    group: 'Identificación',
  },
  {
    id: 'apellidos',
    label: 'Apellidos',
    width: 200,
    sortable: true,
    filter: 'text',
    group: 'Identificación',
  },
  { id: 'movil', label: 'Móvil', width: 130, sortable: true, filter: 'text', group: 'Contacto' },
  {
    id: 'email',
    label: 'Email personal',
    width: 260,
    sortable: true,
    filter: 'text',
    group: 'Contacto',
  },
  {
    id: 'director',
    label: 'Director',
    width: 100,
    sortable: true,
    filter: 'multi',
    group: 'Identificación',
  },
  { id: 'actions', label: 'Acciones', width: 72, fixed: true },
];

export const TABLA_GRUPOS = 'grupos';
export const TABLA_PROFESORES = 'profesores';
